import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { sitesAndTenantsInfoRequest } from '~src/siteManagement/actions/SitesAndTenantsInfoRequestAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { LinkEnabledSitePicker, LinkEnabledSitePickerDispatchProps, LinkEnabledSitePickerOwnProps, LinkEnabledSitePickerStateProps } from './LinkEnabledSitePicker';


const mapStateToProps: MapStateToProps<LinkEnabledSitePickerStateProps> = (state: AppState) => ({
  currentSiteName: SessionSiteSelectors.siteName(state),
  currentSiteUrlName: SessionSiteSelectors.siteUrlName(state),
  sitesAndTenantsInfo: state.sitesAndTenantsInfo
});

const mapDispatchToProps: MapDispatchToProps<LinkEnabledSitePickerDispatchProps> =
  (dispatch) => bindActionCreators({
    requestSitesAndTenantsInfo: sitesAndTenantsInfoRequest
  },
  dispatch);

export const ConnectedLinkEnabledSitePicker: React.ComponentClass<LinkEnabledSitePickerOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(LinkEnabledSitePicker);
